module.exports = __webpack_public_path__ + "media/bootstrap-icons/link-f7c1228e.svg";